import { type FC } from 'react';

import clsx from 'clsx';

import { isTMA } from '@/shared/helpers/is-tma';
import { useTgState } from '@/shared/store/tg-store/tg-store';

import s from './index.module.scss';

const BLUR_STEPS = [
  { blur: 0.15625, from: 0, to: 12.5 },
  { blur: 0.3125, from: 12.5, to: 25 },
  { blur: 0.625, from: 25, to: 37.5 },
  { blur: 1.25, from: 37.5, to: 50 },
  { blur: 2.5, from: 50, to: 62.5 },
  { blur: 5, from: 62.5, to: 75 },
  { blur: 10, from: 75, to: 87.5 },
  { blur: 20, from: 87.5, to: 100 },
];

export interface Props {
  className?: string;
}

export const ProgressiveBlurTop: FC<Props> = ({ className }) => {
  const { isFullscreen } = useTgState();

  const hasFullscreenHeader = isFullscreen || (import.meta.env.DEV && !isTMA());

  if (!hasFullscreenHeader) return null;

  return (
    <div className={clsx(s.container, className)}>
      {BLUR_STEPS.map(({ blur, from, to }, i) => (
        <div
          key={i}
          className={s.step}
          style={{
            backdropFilter: `blur(${blur}px)`,
            WebkitBackdropFilter: `blur(${blur}px)`,
            maskImage: `linear-gradient(to top, rgba(0,0,0,0) ${from}%, rgba(0,0,0,1) ${to}%)`,
            WebkitMaskImage: `linear-gradient(to top, rgba(0,0,0,0) ${from}%, rgba(0,0,0,1) ${to}%)`,
          }}
        />
      ))}
    </div>
  );
};
